<template>
  <div ref="main">
    <div class="opo02">
      <span class="opo03">货道管理</span>
    </div>
    <div class="opo01">
      <!-- <div class="djt30"> -->
<!--        <div class="djt31">-->
<!--          <input v-model="searchs" type="text" placeholder="搜索你想要查找的" placeholder-class="djt32" class="djt33">-->
<!--          <img src="@/assets/images/sea01.png" alt="" class="djt34">-->
<!--        </div>-->
      <!-- </div> -->
      <div style="width: 40%;display: flex;justify-content: space-around;">
        <!--        <div class="djt02" style="margin-right: 20px" @click="xjsp">-->
        <!--          <img src="@/assets/images/qw2.png" class="djt03" alt="">-->
        <!--          <p class="djt04">新建商品</p>-->
        <!--        </div>-->
        <div class="jgs01">
          <p class="jgs02">设备名称</p>
          <div class="bpk02jq">
            <el-select v-model="djg" class="djs04" filterable placeholder="请选择" @change="bpxz">
              <el-option
                v-for="(item,index) in djArr"
                :key="'dj'+index"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
       <!-- <div class="djt02">
         <img src="@/assets/images/jg01.png" class="djt03" alt="">
         <p class="djt04">设置警告</p>
       </div> -->
       <div class="yujin">
        <div class="yujin1">
          <!-- <input class="yujin2" @input="diandian" type="checkbox"> -->
          <img v-if="ishow == 1" src="@/assets/imgs/40.png" @click="check1(2)" class="yujin2" alt="">
          <img v-if="ishow == 2" src="@/assets/imgs/41.png" @click="check1(1)" class="yujin3" alt="">
        </div>
        <el-badge :value="warmNum" class="item">
          <el-button size="small" style="margin-top:3px">缺货货道</el-button>
        </el-badge>
       </div>
      </div>
    </div>
    <div class="djt05">
      <div class="djt06">
        <div class="djt263">设备名称</div>
        <div class="djt263">货道</div>
        <div class="djt263">名称</div>
        <div class="djt263">编码</div>
        <div class="djt263">现库存数量</div>
        <div class="djt263">可出货数量</div>
        <div class="djt263">待出货数量</div>
        <div class="djt263">操作</div>
      </div>
      <el-skeleton animated :loading="loading" :count="6">
        <template slot="template">
          <el-skeleton-item variant="p" style="width: 100%;height: 80px;" />
        </template>
        <template>
          <div class="djt09" v-for="(item,index) in data" :key="'lis'+index">
            <div class="djt272" :title="item.devicename" style="text-align: start">
              <div class="hongd01" v-if="item.currentmaynumber <= item.minstocknum"></div>
              {{item.devicename}}
            </div>
            <div class="djt272" :title="item.code">
              {{item.code}}
              <span v-if="item.channelid != null && item.channelid != ''">（已并道）</span>
            </div>
            <div class="djt272" :title="item.goodsname">{{item.goodsname}}</div>
            <div class="djt272" :title="item.goodscode">{{item.goodscode}}</div>
            <div class="djt272" :title="item.num">{{item.num}}</div>
            <div class="djt272" v-if="!item.is_ed" :title="item.currentmaynumber">{{item.currentmaynumber}}</div>
            <div class="djt273" v-if="item.is_ed">
              <input v-focus type="number" v-model="kchs" class="jgs04">
            </div>
            <div class="djt272" :title="item.currentnomaynumber">{{item.currentnomaynumber}}</div>
            <div class="djt273">
              <div class="djt273-1" v-if="item.channelid != null && item.channelid != ''">
                <img title="拆分" src="@/assets/imgs/29.png" class="djy16d" alt="" @click="chaifen(item)">
                <span>拆分</span>
              </div>
              <div class="djt273-1" v-else>
                <img title="并道" v-if="item.number2 != 1" src="@/assets/imgs/30.png" class="djy16d" alt="" @click="bingdao(item)">
                <img title="禁用" v-else src="@/assets/imgs/37.png" class="djy16-1" alt="">
                <span>并道</span>
              </div>
              <div class="djt273-1" v-if="item.goodscode == null || item.goodscode == ''">
                <img title="上架" src="@/assets/imgs/35.png" class="djy16d" alt="" @click="toSh(item)">
                <span>上架</span>
              </div>
              <div class="djt273-1" v-else>
                <img title="下架" src="@/assets/imgs/36.png" class="djy16d" alt="" @click="xiajia(item)">
                <span>下架</span>
              </div>
              <div class="djt273-1">
                <img title="预警" src="@/assets/imgs/31.png" class="djy16d" alt="" @click="buh(item)">
                <span>预警</span>
              </div>
              <div class="djt273-1" v-if="item.gztype == 1">
                <img title="启用" src="@/assets/imgs/33.png" class="djy16d" alt="" @click="sds(item)">
                <span>启用</span>
              </div>
              <div class="djt273-1" v-else>
                <img title="禁用" src="@/assets/imgs/32.png" class="djy16d" alt="" @click="sds(item)">
                <span>禁用</span>
              </div>
              <div class="djt273-1">
                <img title="修改" src="@/assets/imgs/34.png" class="djy16d" alt="" @click="toEd(item,index)">
                <span>修改</span>
              </div>
              <!-- <img src="@/assets/images/icon24.png" style="margin-right: 20px" title="货道上架" @click="toSh(item)" class="djy16" alt="" >
              <img src="@/assets/images/ljmg.png" style="margin-right: 20px" title="设置警告" @click="buh(item)" class="djy16" alt="" >
              <img src="@/assets/images/sd01.png" style="margin-right: 20px" @click="sds(item)" title="锁定" v-if="item.gztype == 1" class="djy16" alt="" >
              <img src="@/assets/images/sd02.png" style="margin-right: 20px" @click="sds(item)" title="解锁" v-else class="djy16" alt="" >
              <img src="@/assets/images/ed01.png" @click="toEd(item,index)" title="编辑" class="djy166" alt="" > -->
            </div>
          </div>
        </template>
      </el-skeleton>
      <xc-model :loading="shModel" title="货道上架" :is_buttom="false" @cancel="sh_cancel">
        <div slot="mbody">
          <div class="djt17s">
            <div style="margin-top: 60px">
              <div style="position: relative">
                <div class="djy17">
                  <p class="djy18">货物编码：</p>
                  <input type="text" v-model="sh.bm" @change="sh_change" placeholder="请输入货物编码" class="djy19">
                </div>
                <div class="djy20" v-show="spData.length > 0">
                  <p class="djy18" style="opacity: 0;">货物编码：</p>
                  <div class="djy21">
                    <p class="djy22" v-for="(item,index) in spData" :key="'spd'+index" @click="sel_shsp(item)">{{item.name}}-{{item.productcode}}-{{item.orgname}}-{{item.orgname2}}</p>
                  </div>
                </div>
              </div>
              <div class="djy17">
                <p class="djy18">商品信息：</p>
                <input type="text" disabled v-model="sh.item.name" placeholder="请先选择商品" class="djy19">
              </div>
              <div class="djy17">
                <p class="djy18">上货数量：</p>
                <input type="text" v-model="sh.num" placeholder="请输入上货数量" class="djy19">
              </div>
            </div>
            <div class="djt21">
              <div class="djt22" @click="shre_sh">确认</div>
              <div class="djt22" style="margin-left: 50px" @click="sh_cancel">取消</div>
            </div>
          </div>
        </div>
      </xc-model>
      <xc-model :loading="jgModel" title="补货警告" :is_buttom="false" @cancel="cancel">
        <div slot="mbody">
          <div class="djt17s">
            <div style="margin-top: 60px">
              <div style="display: flex;justify-content: center;">
                <div class="djt19">货物少于：</div>
                <input type="text" v-model="jgnum" placeholder="" class="jgs03">
                <div class="djt19" style="padding-left: 15px">件时，进行<span style="color: #FF0000">补货警告</span></div>
              </div>
            </div>
            <div class="djt21">
              <div class="djt22" @click="xgjg">确认</div>
              <div class="djt22" style="margin-left: 50px" @click="cancel">取消</div>
            </div>
          </div>
        </div>
      </xc-model>
      <xc-model :loading="xgsModel" title="修改信息" :is_buttom="false" @cancel="xgs_cancel">
        <div slot="mbody">
          <div class="djt17s">
            <div style="margin-top: 60px">
              <!-- <div class="djy17">
                <p class="djy18">商品名称：</p>
                <input type="text" disabled maxlength="10" v-model="goodsname" placeholder="请输入商品名称" class="djy19">
              </div>
              <div class="djy17">
                <p class="djy18">商品名称：</p>
                <input type="text" disabled maxlength="10" v-model="zuzhijiagou" placeholder="请输入商品名称" class="djy19">
              </div>
              <div class="djy17">
                <p class="djy18">加工产品编码：</p>
                <input type="text" disabled maxlength="10" v-model="productcode" placeholder="请输入加工产品编码" class="djy19">
              </div> -->
              <div class="djy17">
                <p class="djy18">可出货数量：</p>
                <input type="text" maxlength="10" v-model="xgskch" placeholder="请输入可出货数量" class="djy19">
              </div>
              <div class="djy17">
                <p class="djy18">待出货数量：</p>
                <input type="text" maxlength="10" v-model="xgsdch" placeholder="请输入待出货数量" class="djy19">
              </div>
            </div>
            <div class="djt21">
              <div class="djt22" @click="xgsShur">确认</div>
              <div class="djt22" style="margin-left: 50px" @click="xgs_cancel">取消</div>
            </div>
          </div>
        </div>
      </xc-model>
      <div class="djt09" v-if="ishow == 1" style="border-bottom: none;margin-top: 5px;">
        <!-- <el-pagination
          :current-page="sPage"
          @current-change="toPage"
          background
          :page-count="totalPage"
          layout="prev, pager, next"
          class="djt29"
        >
        </el-pagination> -->
        <Page :current-page="sPage" :total="totalPage" :page-size="10" @on-change="toPage"/>
      </div>
      <div class="djt09" v-else style="border-bottom: none;margin-top: 5px;">
        <Page :current-page="sPage" :total="totalPage" :page-size="10" @on-change="toPage1"/>
      </div>
    </div>
    <style>
      .el-input__inner{
        border: none !important;
      }
    </style>
    <div v-show="isJzs" style="top:0;left:0;width: 100%;height: 100%;position: fixed;z-index: 999;display: flex;flex-direction: column;justify-content: center;background-color: rgba(0,0,0,0.2)">
      <div style="width: 100%;height: 200px;display: flex;justify-content: center">
        <img src="../../assets/images/jiaz04.gif" style="width: 50px;height: 50px;margin-top: 75px" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  var me;
  var user;
  import httpUser from "@/api/user";
  import util from '@/util/util';
  import http from 'axios';
  export default {
    name: "djgjb",
    data(){
      return{
        totalPage:0,
        goodsname:'',
        zuzhijiagou:'',
        productcode:'',
        xgsModel:false,
        xgsdch:"",
        xgskch:'',
        searchs:'',
        jgModel:false,
        loading:true,
        pageSize:10,
        page:1,
        data:[],
        name:'',
        num:'',
        spec:'',
        imageUrl: '',
        jiage:'',
        yiji:'',
        erji:'',
        biaop:'',
        yjArr:[],
        erArr:[],
        djArr:[],
        lsItem:[],
        xgModel:false,
        xgjiag:'',
        xgyiji:'',
        xgerji:'',
        djg:'',
        jgnum:2,
        djItem:[],
        djIndex:'',
        kchs:'',
        shModel:false,
        sh:{
          bm:'',
          item:[],
          num:'',
        },
        spData:[],
        isJzs:false,
        sPage:1,
        user:'',
        ishow:1,
        warmNum:0,
        deviceid:''
      }
    },
    created() {
      me = this;
      user = JSON.parse(sessionStorage.getItem('user'));
      me.user = JSON.parse(sessionStorage.getItem('user'));
    },
    mounted() {
      document.addEventListener("click", this.bodyCloseMenus);
      let data = {
        companyid:me.user.companyId,
        page:1,
        pageSize:me.pageSize,
      }
      let data1 = {
        page:1,
        pageSize:1000,
      }
      if (user.companyId != '1') {
        me.$set(data,'companyid',user.companyId);
        me.$set(data1,'companyid',user.companyId);
      }
      http.all([httpUser.getchannellist(data),httpUser.djglist(data1)]).then(http.spread(function (val1,val2) {
        console.log([val1,val2]);
        me.data = val1.data.dataList;
        me.totalPage = val1.data.totalNum
        me.data.forEach(function (item,index) {
          me.$set(item,'is_ed',false);
        })
        me.djArr = val2.data.dataList
        me.loading = false;
      }))
      let data2 = {
        deviceid:me.deviceid,
        page:1,
        pageSize:10,
        companyid:user.companyId
      }
      httpUser.getchannelwarn(data2).then(res=>{
        me.warmNum = res.data.totalNum
      })
    },
    beforeDestroy() {
      document.removeEventListener("click", this.bodyCloseMenus);
    },
    methods:{
      // 预警
      check1(e){
        me.ishow = e
        if(e == 2) {
          let data = {
            deviceid:me.deviceid,
            page:1,
            pageSize:10,
            companyid:user.companyId
          }
          httpUser.getchannelwarn(data).then(res=>{
            me.data = res.data.dataList;
            me.warmNum = res.data.totalNum
            me.totalPage = res.data.totalNum
          })
        }else{
          let data1 = {
            companyid:me.user.companyId,
            page:me.page,
            pageSize:me.pageSize,
            deviceid:me.deviceid
          }
          httpUser.getchannellist(data1).then(res => {
            me.data = res.data.dataList;
            me.totalPage = res.data.totalNum
            me.warmNum = 0
            me.data.forEach(function (item,index) {
              me.$set(item,'is_ed',false);
            })
          })
        }
      },
      // 下架
      xiajia(item){
        let data = {
          id:item.id,
          isdel:'2'
        }
        let data1 = {
          companyid:me.user.companyId,
          page:me.page,
          pageSize:me.pageSize,
        }
        httpUser.addorupdatecupchannel(data).then(res=>{
          if(res.code == '0000') {
            httpUser.getchannellist(data1).then(res => {
            me.data = res.data.dataList;
            me.totalPage = res.data.totalNum
            me.data.forEach(function (item,index) {
              me.$set(item,'is_ed',false);
            })
            me.djg = ''
            me.$Loading.finish();
            me.$message.success('已下架')
          })
          }
        })
      },
      // 拆分
      chaifen(item){
        let data  = {
          channelid:item.id
        }
        let data1 = {
          companyid:me.user.companyId,
          page:me.page,
          pageSize:me.pageSize,
        }
        httpUser.cancelchannel(data).then(res=>{
         if(res.code == '0000') {
          httpUser.getchannellist(data1).then(res => {
            me.data = res.data.dataList;
            me.totalPage = res.data.totalNum
            me.data.forEach(function (item,index) {
              me.$set(item,'is_ed',false);
            })
            me.$Loading.finish();
            me.$message.success('拆分成功')
          })
         }
        })
      },
      // 并道
      bingdao(item){
        let data  = {
          channelid:item.id
        }
        let data1 = {
          companyid:me.user.companyId,
          page:me.page,
          pageSize:me.pageSize,
        }
        httpUser.andchannel(data).then(res=>{
         if(res.code == '0000') {
          httpUser.getchannellist(data1).then(res => {
            me.data = res.data.dataList;
            me.totalPage = res.data.totalNum
            me.data.forEach(function (item,index) {
              me.$set(item,'is_ed',false);
            })
            me.$Loading.finish();
            me.$message.success('合并成功')
          })
         }else if(res.code == '1001') {
          me.$message,error('第一列不能并道')
         }else if(res.code == '1111 ') {
          me.$message,error('并道失败')
         }
        })
      },
      xgsShur(){/*确定修改*/
        if (me.xgskch === '' || me.xgsdch === '') {
          me.$message.error('可出货数量和待出货数量不能为空');
          return false;
        }
        if (util.checkSpace(me.xgskch) || util.checkSpace(me.xgsdch)) {
          me.$message.error('可出货数量和待出货数量不能含有空格');
          return false;
        }
        if (util.noBq().test(me.xgskch) || util.noBq().test(me.xgsdch)) {
          me.$message.error('可出货数量和待出货数量不能含有表情');
          return false;
        }
        me.$Loading.start();
        let data = {
          id:me.djItem.id,
          currentmaynumber:me.xgskch,
          currentnomaynumber:me.xgsdch,
        }
        httpUser.addorupdatecupchannel(data).then(res => {
          switch (res.code) {
            case "0000":
              let data = {
                companyid:me.user.companyId,
                page:me.page,
                pageSize:me.pageSize,
              }
              if (user.companyId != '1') {
                me.$set(data,'companyid',user.companyId);
              }
              if (me.djg != '') {
                me.$set(data,'deviceid',me.djg);
              }
              httpUser.getchannellist(data).then(res => {
                me.data = res.data.dataList;
                me.totalPage = res.data.totalNum
                me.data.forEach(function (item,index) {
                  me.$set(item,'is_ed',false);
                })
                me.$Loading.finish();
                me.xgsModel = false;
                me.$message.success('已设置');
              })
              break;
            case "1111":
              me.$Loading.error();
              me.$message.error('请稍后再试');
              break;
          }
        })
      },
      xgs_cancel(){/*修改返回*/
        me.xgsModel = false;
      },
      shre_sh(){/*确定上货*/
        if (me.sh.bm == '') {
          me.$message.error('请输入商品编码');
          return false;
        }
        if (me.sh.item == []) {
          me.$message.error('请先选择商品');
          return false;
        }
        if (me.sh.num == '') {
          me.$message.error('请输入数量');
          return false;
        }
        if (!util.checkIntAndFloat(me.sh.num)) {
          me.$message.error('数量只能输入整数');
          return false;
        }
        me.isJzs = true;
        let data = {
          id:me.lsItem.id,
          // code:me.lsItem.code,
          goodsid:me.sh.item.id,
          sellprice:me.sh.item.price,
          currentmaynumber:me.sh.num,
        }
        httpUser.addorupdatecupchannel(data).then(res => {
          me.isJzs = false;
          switch (res.code) {
            case "0000":
              let data = {
                companyid:me.user.companyId,
                page:me.page,
                pageSize:me.pageSize,
              }
              if (user.companyId != '1') {
                me.$set(data,'companyid',user.companyId);
              }
              if (me.djg != '') {
                me.$set(data,'deviceid',me.djg);
              }
              httpUser.getchannellist(data).then(res => {
                me.data = res.data.dataList;
                me.totalPage = res.data.totalNum
                me.data.forEach(function (item,index) {
                  me.$set(item,'is_ed',false);
                })
                me.sh_cancel();
                me.isJzs = false;
                me.$message.success('已设置');
              })
              break;
            case "1111":
              me.$message.error('系统错误，请稍后再试');
              break;
          }
        })
      },
      sel_shsp(item){/*点击的商品*/
        me.sh.item = item;
        me.spData = [];
      },
      sh_change(e){/*监听上货输入框*/
        console.log(e);
        if (me.sh.bm == '') {
          return false;
        }
        let data = {
          code:me.sh.bm,
          page:1,
          pageSize:100,
          companyid:user.companyId,
          isup:2,
        }
        httpUser.getgoodslistSh(data).then(res => {
          me.spData = res.data.dataList;
          console.log(me.spData,'goods');
        })
      },
      toSh(item){/*前往上货*/
        console.log(item);
        if (item.channelid != null && item.channelid != '') {
          me.$message.error('该货道已被并道，无法设置商品');
          return false;
        }
        me.lsItem = item;
        me.shModel = true;
      },
      sh_cancel(){/*上货返回*/
        me.shModel = false;
        setTimeout(function () {
          me.sh.bm = '';
          me.sh.item = [];
          me.sh.num = '';
          me.spData = [];
        },500)
      },
      bodyCloseMenus(e){
        console.log(e,'iop');
        console.log(me.djItem,'opl');
        if (e.target.className != 'djy16d' && e.target.className != 'djy166' && me.djItem != [] && me.djItem.is_ed == true) {
          if (me.kchs != me.djItem.currentmaynumber) {
            if (!(/(^[0-9]\d*$)/.test(me.kchs))) {
              me.$message.error('库存不能为负数或者小数');
              return false;
            }
            me.$Loading.start();
            let data = {
              id:me.djItem.id,
              currentmaynumber:me.kchs,
            }
            httpUser.addorupdatecupchannel(data).then(res => {
              switch (res.code) {
                case "0000":
                  let data = {
                    companyid:me.user.companyId,
                    page:me.page,
                    pageSize:me.pageSize,
                  }
                  if (user.companyId != '1') {
                    me.$set(data,'companyid',user.companyId);
                  }
                  if (me.djg != '') {
                    me.$set(data,'deviceid',me.djg);
                  }
                  httpUser.getchannellist(data).then(res => {
                    me.data = res.data.dataList;
                    me.totalPage = res.data.totalNum
                    me.data.forEach(function (item,index) {
                      me.$set(item,'is_ed',false);
                    })
                    me.$Loading.finish();
                    me.data.dataList[me.djIndex].is_ed = false;
                    me.$message.success('已设置');
                  })
                  break;
                case "1111":
                  me.$Loading.error();
                  me.$message.error('请稍后再试');
                  break;
              }
            })
          } else {
            me.data.dataList[me.djIndex].is_ed = false;
          }
          me.djItem = [];
        }
      },
      toEd(item,index){//点击编辑
        console.log(item,"item")
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth = util.is_Auth(menu,'刀具柜管理','编辑货道');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        // if (me.djIndex !== '') {
        //   me.data.dataList[me.djIndex].is_ed = false;
        // }
        // item.is_ed = !item.is_ed;
        // me.djIndex = index;
        me.djItem = item;
        me.xgskch = item.currentmaynumber;
        me.xgsdch = item.currentnomaynumber;
        me.goodsname = item.goodsname
        me.zuzhijiagou = item.orgname + '-' + item.orgname2
        me.productcode = item.productcode
        me.xgsModel = true;
      },
      sds(item){//解锁或者锁定
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth = util.is_Auth(menu,'刀具柜管理','编辑货道');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        me.$Loading.start();
        let data = {
          id:item.id,
          gztype:'',
        }
        if (item.gztype == 1) {
          data['gztype'] = 2;
        } else {
          data['gztype'] = 1;
        }
        httpUser.addorupdatecupchannel(data).then(res => {
          switch (res.code) {
            case "0000":
              let data = {
                companyid:me.user.companyId,
                page:me.page,
                pageSize:me.pageSize,
              }
              if (user.companyId != '1') {
                me.$set(data,'companyid',user.companyId);
              }
              if (me.djg != '') {
                me.$set(data,'deviceid',me.djg);
              }
              httpUser.getchannellist(data).then(res => {
                me.data = res.data.dataList;
                me.totalPage = res.data.totalNum
                me.data.forEach(function (item,index) {
                  me.$set(item,'is_ed',false);
                })
                me.jgModel = false;
                me.$Loading.finish();
                me.$message.success('已设置');
                console.log(res);
              })
              break;
            case "1111":
              me.$Loading.error();
              me.$message.error('请稍后再试');
              break;
          }
        })
      },
      xgjg(){//修改警告
        if (!(/(^[0-9]\d*$)/.test(me.jgnum))) {
          me.$message.error('不能为负数或者小数');
          return false;
        }
        me.$Loading.start();
        let data = {
          id:me.lsItem.id,
          minstocknum:me.jgnum,
          gztype:me.lsItem.gztype,
        }
        httpUser.addorupdatecupchannel(data).then(res => {
          switch (res.code) {
            case "0000":
              let data = {
                companyid:me.user.companyId,
                page:me.page,
                pageSize:me.pageSize,
              }
              if (user.companyId != '1') {
                me.$set(data,'companyid',user.companyId);
              }
              if (me.djg != '') {
                me.$set(data,'deviceid',me.djg);
              }
              httpUser.getchannellist(data).then(res => {
                me.data = res.data.dataList;
                me.totalPage = res.data.totalNum
                me.data.forEach(function (item,index) {
                  me.$set(item,'is_ed',false);
                })
                me.jgModel = false;
                me.$Loading.finish();
                me.$message.success('已设置');
                console.log(res);
              })
              break;
            case "1111":
              me.$Loading.error();
              me.$message.error('请稍后再试');
              break;
          }
        })
      },
      buh(item){//补货打开
        let menu = JSON.parse(sessionStorage.getItem('menu'));
        let is_auth = util.is_Auth(menu,'刀具柜管理','编辑货道');
        if (is_auth == false) {
          me.$message.error('暂无权限');
          return false;
        }
        console.log(item);
        me.jgnum = item.minstocknum;
        me.lsItem = item;
        me.jgModel = true;
      },
      bpxz(e){//选中设备后
        console.log(e,'1234');
        me.deviceid = e
        me.page = 1;
        me.sPage = 1;
        me.loading = true;
        if(me.ishow == 2){
          let data = {
            deviceid:e,
            page:1,
            pageSize:10,
            companyid:user.companyId
          }
          httpUser.getchannelwarn(data).then(res=>{
            me.data = res.data.dataList;
            me.warmNum = res.data.totalNum
            me.totalPage = res.data.totalNum
            me.loading = false;
          })
        }else{
          let data = {
            companyid:me.user.companyId,
            page:1,
            pageSize:me.pageSize,
            deviceid:e,
          }
          if (user.companyId != '1') {
            me.$set(data,'companyid',user.companyId);
          }
          httpUser.getchannellist(data).then(res => {
            me.data = res.data.dataList;
            me.totalPage = res.data.totalNum
            me.data.forEach(function (item,index) {
              me.$set(item,'is_ed',false);
            })
            me.loading = false;
            console.log(res);
          })
        }
      },
      toPage1(e){
        me.loading = true;
        let data = {
            deviceid:me.deviceid,
            page:e,
            pageSize:10,
            companyid:user.companyId
          }
          httpUser.getchannelwarn(data).then(res=>{
            me.data = res.data.dataList;
            me.warmNum = res.data.totalNum
            me.totalPage = res.data.totalNum
            me.loading = false;
          })
      },
      toPage(e){//分页
        me.loading = true;
        let data = {
          companyid:me.user.companyId,
          page:e,
          pageSize:me.pageSize,
        }
        if (user.companyId != '1') {
          me.$set(data,'companyid',user.companyId);
        }
        if (me.djg != '') {
          me.$set(data,'deviceid',me.djg);
        }
        me.page = e;
        me.sPage = parseInt(e);
        httpUser.getchannellist(data).then(res => {
          me.data = res.data.dataList;
          me.totalPage = res.data.totalNum
          me.data.forEach(function (item,index) {
            me.$set(item,'is_ed',false);
          })
          me.loading = false;
          console.log(res);
        })
      },
      cancel(){
        me.jgModel = false;
      }
    }
  }
</script>

<style scoped>
@import "djgjb.css";
</style>